<div
    *ngIf="this.selectedPhoto"
    class="image-container"
    (click)="close()">
    <div class="buttons-holder">
        <div
            *ngIf="selectedPhoto.isWinner === '1'"
            class="winner-cup-icon">
            <img src="/assets/images/winner-cup.png" />
        </div>
        <button
            class="set-winner-btn btn-styled"
            *ngIf="selectedPhoto.isWinner === '0'"
            (click)="setAsWinner($event)">
            Set as winner
        </button>
        <i
            class="fas fa-download mr-2"
            (click)="downloadImage(selectedPhoto.url)"></i>
        <svg-icon
            [svgStyle]="{ 'width.px': 22, 'height.px': 22, fill: '#fff', cursor: 'pointer' }"
            src="assets/images/icon-menu-close.svg"></svg-icon>
    </div>
    <button
        class="prev-btn btn-styled"
        *ngIf="veiwingPhotoIndex > 0"
        (click)="prevClicked($event)">
        Prev
    </button>
    <img src="{{ selectedPhoto.url }}" />
    <button
        class="next-btn btn-styled"
        *ngIf="veiwingPhotoIndex < photos.length - 1"
        (click)="nextClicked($event)">
        Next
    </button>
</div>
